import React, { useState, useEffect } from 'react';
import { MotifIcon } from '@ey-xd/motif-react';
import {
  SidebarContainer,
  SidebarExpandedContainer,
  SidebarCollapsedContainer,
  SidebarWarningContainer,
  SidebarWarningText,
  SidebarWarningIcon,
  ParentLoadingContainer,
  ChildLoadingContainer,
} from '@atoms/sidebar/sidebar.styles';
import { getTodaysDate } from '@util/commonUtil';
import {
  Current_User,
  Now_Next_Beyond_Sidebar_Data_State,
  Recoil_Quarter_State,
  Refresh_Pl_Sidebar_Data,
  Trigger_Update_Pl_Sidebar_Data,
  SidebarExpandCollapseState,
  System_Date_Time_State,
  Full_Page_Loading_State,
  Pl_Failure_Modal_State,
  Show_Refresh_button_State,
} from '@recoil/recoil';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { getNowNextBeyondSidebarData } from '@services/pursuitLeaderServices';
import {
  FORECAST_SIDEBAR_DATA_CONST,
  FORECAST_SIDEBAR_QUARTER_CONST,
  SIDEBAR_WARNING,
} from '@constants/commonConstants';
import SpinnerLoader from '@atoms/SpinnerLoader';
import QuarterlyCollapsedSidebar from '@molecules/pursuitLeader/components/quarterlyCollapsedSidebar';
import QuarterlyExpandedSidebar from '@molecules/pursuitLeader/components/quarterlyExpandedSidebar';
import { actionIcReportProblem24px } from '@ey-xd/motif-react/assets/icons';
import { isMobile, isTablet } from 'react-device-detect';
import { logError } from '@util/commonFunctions';

const QuarterlySidebar = () => {
  const [triggerUpdatePlSidebarData, setTriggerUpdatePlSidebarData] = useRecoilState(
    Trigger_Update_Pl_Sidebar_Data,
  );
  const [expandedQuarter, setExpandedQuarter] = useState('');
  const [nowNextBeyondSidebarData, setNowNextBeyondSidebarData] = useRecoilState(
    Now_Next_Beyond_Sidebar_Data_State,
  );
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarExpandState, setSidebarExpandState] = useRecoilState(SidebarExpandCollapseState);
  const setIsFullPageLoading = useSetRecoilState(Full_Page_Loading_State);
  const [refreshPLSidebarData, setRefreshPLSidebarData] = useRecoilState(Refresh_Pl_Sidebar_Data);
  const setShowFailureSubmitModal = useSetRecoilState(Pl_Failure_Modal_State);
  const setShowRefreshButton = useSetRecoilState(Show_Refresh_button_State);

  const todaysDate = getTodaysDate(systemDateTime);
  let currentYear;
  const sidebarData = {
    NOW: null,
    NEXT: null,
    // BEYOND: null,
  };
  const screenWidth = window.innerWidth;

  setTimeout(() => {
    if (quarterData !== null && expandedQuarter === '') {
      const expandThisQuarter = quarterData.quarter;
      setExpandedQuarter(expandThisQuarter);
    }
  }, 1000);

  if (quarterData !== null) {
    currentYear = quarterData.fiscal_year;
  }

  useEffect(() => {
    if ((isMobile || isTablet) && screenWidth < 1170 && !sidebarExpandState) {
      setSidebarExpandState(!sidebarExpandState);
      localStorage.setItem('isSidebarExpanded', !sidebarExpandState);
    }
  }, []);

  useEffect(() => {
    if (quarterData != null && refreshPLSidebarData) {
      const fetchData = async () => {
        try {
          // NOW
          const nowSideBarData = await getNowNextBeyondSidebarData(
            FORECAST_SIDEBAR_DATA_CONST.NOW,
            currentUser.email,
            todaysDate,
            currentYear,
            null,
          );
          sidebarData.NOW = nowSideBarData;

          // NEXT
          const nextSideBarData = await getNowNextBeyondSidebarData(
            FORECAST_SIDEBAR_DATA_CONST.NEXT,
            currentUser.email,
            todaysDate,
            currentYear,
            null,
          );
          sidebarData.NEXT = nextSideBarData;

          // // BEYOND
          // const beyondSideBarData = await getNowNextBeyondSidebarData(
          //   FORECAST_SIDEBAR_DATA_CONST.BEYOND,
          //   currentUser.email,
          //   todaysDate,
          //   currentYear,
          //   quarterData.quarter,
          // );
          // sidebarData.BEYOND = beyondSideBarData;

          setNowNextBeyondSidebarData(sidebarData);

          if (sessionStorage.getItem('CrmUpdatedOpportunities')) {
            setTriggerUpdatePlSidebarData(!triggerUpdatePlSidebarData);
            setTimeout(() => {
              setIsLoading(false);
              setIsFullPageLoading(false);
              setRefreshPLSidebarData(false);
            }, 2000);
          } else {
            setIsLoading(false);
            setRefreshPLSidebarData(false);
          }
        } catch (error) {
          setShowFailureSubmitModal(true); // Showing Error Modal if any submit APIs Fail
          setShowRefreshButton(true); // To show refresh button in error modal
          logError('getNowNextBeyondSidebarData', error);
          setIsLoading(false);
          setIsFullPageLoading(false);
          setRefreshPLSidebarData(false);
        }
      };

      fetchData();
    }
  }, [refreshPLSidebarData]);

  const toggleAccordion = quarter => {
    if (expandedQuarter === quarter) {
      setExpandedQuarter(null);
    } else {
      setExpandedQuarter(quarter);
    }
  };

  // {!isMobile && screenWidth > 1170 ? (
  return (
    <>
      {isLoading ? (
        <ParentLoadingContainer>
          <ChildLoadingContainer>
            <SpinnerLoader color="#ffffff" />
          </ChildLoadingContainer>
        </ParentLoadingContainer>
      ) : (
        <SidebarContainer>
          {nowNextBeyondSidebarData && !sidebarExpandState ? (
            <SidebarCollapsedContainer>
              {Object?.entries(nowNextBeyondSidebarData)?.map(([key, item]) => (
                <QuarterlyCollapsedSidebar
                  key={key}
                  data={item?.quarterInfoData}
                  quarter={item?.quarter}
                  quarterTitle={item?.title_name}
                />
              ))}
            </SidebarCollapsedContainer>
          ) : (
            <SidebarExpandedContainer>
              <SidebarWarningContainer>
                <SidebarWarningIcon>
                  <MotifIcon
                    style={{ color: '#ED6500', width: '24px', height: '24px' }}
                    src={actionIcReportProblem24px}
                  />
                </SidebarWarningIcon>
                <SidebarWarningText>{SIDEBAR_WARNING.WARNING_MESSAGE}</SidebarWarningText>
              </SidebarWarningContainer>
              {nowNextBeyondSidebarData ? (
                <>
                  {Object?.entries(nowNextBeyondSidebarData)?.map(([key, item]) => (
                    <QuarterlyExpandedSidebar
                      key={key}
                      data={item?.quarterInfoData}
                      quarter={
                        item?.title_name === FORECAST_SIDEBAR_QUARTER_CONST.BEYOND
                          ? item?.beyond_quarter
                          : item?.quarter
                      }
                      quarterTitle={item?.title_name}
                      year={
                        item?.title_name === FORECAST_SIDEBAR_QUARTER_CONST.BEYOND
                          ? item?.beyond_year
                          : item?.year
                      }
                      expanded="expanded"
                      toggleAccordion={() => toggleAccordion('Q1')}
                    />
                  ))}
                </>
              ) : null}
            </SidebarExpandedContainer>
          )}
        </SidebarContainer>
      )}
    </>
  );
};

export default QuarterlySidebar;
